<template>
    <div
        v-if="props.enabled"
        class="hidden md:flex absolute z-10 items-center justify-center cursor-col-resize group touch-none"
        :class="{ 'is-resizing': props.isResizing }"
        :style="props.handleStyle"
        role="separator"
        aria-orientation="vertical"
        aria-label="Resize pane"
        @mousedown="emit('start', $event)"
        @touchstart="emit('start', $event)"
    >
        <span
            class="block w-1 h-12 rounded-full bg-slate-300 transition-colors group-hover:bg-slate-400 group-[.is-resizing]:bg-slate-400"
        ></span>
    </div>
</template>

<script lang="ts" setup>
import type { CSSProperties } from 'vue';

const props = defineProps<{
    enabled: boolean;
    isResizing: boolean;
    handleStyle: CSSProperties;
}>();

const emit = defineEmits<{
    start: [event: MouseEvent | TouchEvent];
}>();
</script>
